// UserId
export const getUserId = () => localStorage.getItem('userId');
export const setUserId = (userId) => localStorage.setItem('userId', userId);

// Billing Details
export const getBillingDetails = () => {
    const encodedBillingDetails = localStorage.getItem('billingDetails');
    if (encodedBillingDetails === null) return null;

    try {
        const decodedBillingDetailsInJson = window.atob(encodedBillingDetails);
        const billingDetails = JSON.parse(decodedBillingDetailsInJson);

        return billingDetails;
    } catch {
        // Return null if decoding or parsing of billing details fails
        return null;
    }
};

export const setBillingDetails = (billingEmail, billingName, billingContact) => {
    const billingDetails = {};

    if (billingEmail) billingDetails.billingEmail = billingEmail;
    if (billingName) billingDetails.billingName = billingName;
    if (billingContact) billingDetails.billingContact = billingContact;

    const billingDetailsInJson = JSON.stringify(billingDetails);
    const encodedBillingDetails = window.btoa(billingDetailsInJson);

    localStorage.setItem('billingDetails', encodedBillingDetails);
};

export const removeBillingDetails = () => localStorage.removeItem('billingDetails');
